import { render, staticRenderFns } from "./MaterialG.vue?vue&type=template&id=001039cf"
import script from "./MaterialG.vue?vue&type=script&lang=js"
export * from "./MaterialG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports